import React from "react";
import BaseRemixModal from "@components/common/BaseRemixModal";

/**
 * AgendaRemixModal - Modal for remixing entire agenda using the shared BaseRemixModal
 */
const AgendaRemixModal = ({
  isOpen,
  agenda,
  onClose,
  onRemixComplete,
  isLoading = false,
}) => {
  return (
    <BaseRemixModal
      isOpen={isOpen}
      entity={{agenda}}
      entityType="agenda"
      onClose={onClose}
      onRemixComplete={onRemixComplete}
      isLoading={isLoading}
      title="What would you like to refine?"
      switchLabel="Keep same activity types"
      buttonText="✨ Remix Agenda"
    />
  );
};

export default AgendaRemixModal;
